module.exports = __webpack_public_path__ + "img/selected-box.e74f9ed2.svg";